
import { Component, Prop, Vue } from "vue-property-decorator";
import { ReportItemFormat } from "@/lib/model/exambuilder/exam-component/company";
import { ReportShowConfigV5Item } from "@/lib/model/exambuilder/exam-component/report";

@Component({
  components: {}
})
export default class ParamEdit extends Vue {
  @Prop({}) editItem!: {
    config: ReportItemFormat;
    value: ReportShowConfigV5Item;
  };

  created() {
    return;
  }

  editCancel() {
    this.$emit("close", false);
  }

  editOk() {
    (this.$refs["form"] as any)?.validate((valid: boolean) => {
      if (!valid) return;

      console.log("editItem: ", this.editItem);
      this.$emit("ok", this.editItem);
    });
  }
}
